import { render } from "./Alert.vue?vue&type=template&id=0392e45a"
import script from "./Alert.vue?vue&type=script&lang=js"
export * from "./Alert.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Modal/Alert.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0392e45a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0392e45a', __exports__)) {
    api.reload('0392e45a', __exports__)
  }
  
  module.hot.accept("./Alert.vue?vue&type=template&id=0392e45a", () => {
    api.rerender('0392e45a', render)
  })

}


export default __exports__